module.exports = {"650103001":"长江路街道","650103002":"和田街街道","650103003":"扬子江路街道","650103004":"友好南路街道","650103005":"友好北路街道","650103006":"八一街道","650103007":"炉院街街道","650103008":"西山街道","650103009":"雅玛里克山街道","650103010":"红庙子街道","650103011":"长胜东街道","650103012":"长胜西街道","650103013":"长胜南街道","650103014":"火车南站街道","650103015":"仓房沟片区街道","650103016":"环卫路街道","650103017":"骑马山街道","650103018":"平顶山街道","650103501":"兵团农十二师一零四团","650103502":"兵团十二师西山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650103.json
// module id = 3190
// module chunks = 0